// extracted by mini-css-extract-plugin
export default {"table-loader-box":"ClusterTable_table-loader-box__dQiUb","table-row-clickable":"ClusterTable_table-row-clickable__QGpqY","no-data":"ClusterTable_no-data__DhiWo"};